import React from 'react'
import { ReactComponent } from './arrow-left.svg'
import { MergeReactElementProps } from '../types'

interface ArrowLeftProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', ArrowLeftProps>

export const ArrowLeft = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
